import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé ! Connectez-vous.");
      navigate("/connexion");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-12 sm:py-16 lg:py-20 flex justify-center" data-testid="reset-password-page">
      <div className="w-full max-w-md px-4">
        <Card className="border-slate-200">
          <CardContent className="p-6 sm:p-8 space-y-5">
            <div className="h-12 w-12 rounded-2xl bg-emerald-100 flex items-center justify-center">
              <KeyRound className="h-6 w-6 text-emerald-700" />
            </div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-900" data-testid="reset-password-title">Nouveau mot de passe</h1>
            {!token ? (
              <div className="space-y-4" data-testid="reset-password-invalid">
                <p className="text-sm text-slate-600">Lien de réinitialisation invalide. Redemandez un lien depuis la page de connexion.</p>
                <Button variant="outline" className="w-full" asChild>
                  <Link to="/mot-de-passe-oublie">Redemander un lien</Link>
                </Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="reset-password">Nouveau mot de passe (8 caractères min.)</Label>
                  <Input id="reset-password" data-testid="reset-password-input" type="password" required minLength={8} autoComplete="new-password"
                    value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="reset-confirm">Confirmation</Label>
                  <Input id="reset-confirm" data-testid="reset-confirm-input" type="password" required minLength={8} autoComplete="new-password"
                    value={confirm} onChange={(e) => setConfirm(e.target.value)} />
                </div>
                <Button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700" disabled={loading} data-testid="reset-submit-btn">
                  {loading ? "Enregistrement…" : "Réinitialiser"}
                </Button>
                <p className="text-center">
                  <Link to="/connexion" className="text-sm text-sky-700 hover:underline" data-testid="reset-back-login-link">
                    Retour à la connexion
                  </Link>
                </p>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
